import React, { PureComponent,useRef } from "react";
import { Form ,Button,Col,Row, message} from 'antd';
import mes1 from 'images/edu/mes1.png';
import message01 from 'images/soldier/message1.png';
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import Bmap from "./map"
import imageUrl from '../../img/DetailsFigure.png';
import { getCurrentUser } from 'utils/storage';
import {getStatus} from '@/utils/methods';
import ApproveModal from '@/components/ApproveModal'
const FormItem  = Form.Item
require ("./createAssistItem.scss");
export default class DeucationTrainingPolicyDetail extends PureComponent {
    
    state = {
        sourseId:'',
        courseInfo:{},
        imageUrls:imageUrl,
        optionData:[
            {
                text:"这是基地详细介绍这是基地详细介绍详细介绍介绍",
                time:"2021年11月9号"
            },
            {
                text:"这是基地详细介绍这是基地详细介绍详细介绍介绍",
                time:"2021年11月9号"
            },
            {
                text:"这是基地详细介绍这是基地详细介绍详细介绍介绍",
                time:"2021年11月9号"
            },
            {
                text:"这是基地详细介绍这是基地详细介绍详细介绍介绍",
                time:"2021年11月9号"
            },
        ]
    }
    componentDidMount(){
        console.log('看一下有哪些信息',this.props.location.pathname.split('/').slice(-1));
        let sourseId = this.props.location.pathname.split('/').slice(-1)
        this.getDetail(sourseId[0])
        this.setState({sourseId:sourseId[0]})
        this.modalRef = React.createRef();
    }
    handleJobDetail = (e) => {
        message.config({
            top: 50,
            duration: 1,
            maxCount: 1
        })
        if(!getCurrentUser()){
            message.error("还未登录，请先登录后再申请！");
            this.props.history.push("/login");
            return;
            
          }
        if(getCurrentUser().user_type!='2'){
            message.warn("非退役军人不可申请!");
            return;
        }
        getStatus().then(res=>{
        if(res===false){
            this.modalRef.current.showModal();
            return;
        }
        const { sourseId } = this.state
        e.stopPropagation()
        // window.location = `/AssistLication`
        this.props.history.push(`/entrance/entrepreneurship/AssistLication/${sourseId}`);
                                //   entrance/entrepreneurship/AssistLication
        console.log('this.props.history',e);
        })
      };
    //获取详情
    getDetail = (data) =>{
        console.log('id信息',data);
        let params = {
            id : data
        }
        Http.getApplication(Request.startBaseDetail(),{...params},(obj)=>{
            console.log(obj);
            if(obj.code == 200){
               this.setState({
                   courseInfo:obj.data,
                //    courseList:obj.data.records
               })
               console.log('obj.data,',obj.data);
               
            }
       })
    } 

    renderBaesInfo = () =>{
        const { courseInfo ,imageUrls} = this.state
        let mapData = []
        if(courseInfo.projectList !== undefined){
            mapData = courseInfo.projectList == undefined ? '':courseInfo.projectList
          }
        return mapData.map((item, index)=>{
            return(
            <ul >
                <li className="conBox_footer_right">
                    <div>
                        <img style={{width:94,height:57}} src={item.epalProjectImage?item.epalProjectImage:imageUrls} alt="" />
                    </div>
                    <div>
                        <p>{item.epalProjectText}</p>
                        <p>{item.epalProjectTime}</p>
                    </div>
                </li>
            </ul>
            )
        })
    }

    render() {
        const { courseInfo ,imageUrls} = this.state
        let photoUrl = {}
        console.log('courseInfocourseInfo',courseInfo);
        

        console.log('photoUrlphotoUrl',photoUrl);
        
        return (
            <div className="ImbarkBaseDetails_app">
                <div className="Base_Detils_Box">
                        <span>当前位置：创业帮扶 / <span  style={{cursor:'pointer'}} onClick={()=>this.props.history.push('/entrance/entrepreneurship')}>创业基地</span>/ </span>
                        <span style={{ color: "#3356C5" }}> 基地详情</span>
                </div>
                <div  className="conBox">
                   <div className="conBox_center" style={{background:"url("+(courseInfo.epalBasePhoto?courseInfo.epalBasePhoto:imageUrls)+")"+ "no-repeat"}}>
                       <div>
                        <div>
                            <span>{courseInfo.epalBaseName}</span>
                            <Button onClick={(e)=>{this.handleJobDetail(e)}} className="pagination_footer_but" type='primary'>申请入驻</Button>
                        </div>
                        <div>
                            <p>
                                <span>联系人：</span>
                                <span>{courseInfo.epalBaseResponsible}</span>
                            </p>
                            <p>
                                <span>联系电话：</span>
                                <span>{courseInfo.epalBaseTel}</span>
                            </p>
                        </div>
                        <p>{courseInfo.epalBaseIntroduce}</p>
                       </div>
                   </div>
                   <div className="conBox_footer">
                       <div>
                           <p>
                               <span></span>
                               <span>基地地图</span>
                           </p>
                           <p>
                               <span>基地地址：</span>
                               <span>眉山市永和大道北3巷</span>
                           </p>
                           <div>
                             <Bmap/>
                           </div>
                       </div>
                       <div>
                            <p>
                               <span></span>
                               <span>基地项目列表</span>
                           </p>
                            {this.renderBaesInfo()}
                       </div>
                       <ApproveModal ref = {this.modalRef}/>
                   </div>
                </div>
            </div>
        );
    }
}
